import { Form } from '@component/forms/common.style';
import { UserProfileForm } from '@form/user-profile/user-profile.form';

import { useUserProfile } from './user-profile.hook';

export const UserProfile = () => {
  const { form, isLoading, error, onUpdate } = useUserProfile();

  return (
    <Form.Provider onFormFinish={onUpdate}>
      <UserProfileForm error={error} form={form} isLoading={isLoading} />
    </Form.Provider>
  );
};
